module.exports = __webpack_public_path__ + "static/media/camera.a0ea3b6b.svg";